import { CEP_Config } from "vite-cep-plugin";
import { version } from "./package.json";

const config: CEP_Config = {
	version,
	id: "com.curves.cep",
	displayName: "Curves",
	symlink: "local",
	port: 3000,
	servePort: 5000,
	startingDebugPort: 8860,
	extensionManifestVersion: 6.0,
	requiredRuntimeVersion: 9.0,
	hosts: [
		{
			name: "AEFT",
			version: "[0.0,99.9]",
		},
	],

	type: "Panel",
	iconDarkNormal: "./src/assets/light-icon.png",
	iconNormal: "./src/assets/dark-icon.png",
	iconDarkNormalRollOver: "./src/assets/light-icon.png",
	iconNormalRollOver: "./src/assets/dark-icon.png",
	//@ts-ignore
	parameters: ["--v=0", "--enable-nodejs", "--mixed-context", "--windowless-frame-rate=60","--disable-frame-rate-limit","--disable-gpu-vsync","--disable-gpu","--disable-gpu-compositing","--hardware-acceleration=false","--hardware-video-decode-framerate=0","--enable-begin-frame-scheduling" ],
	width: 500,
	height: 550,

	panels: [
		{
			mainPath: "./main/index.html",
			name: "main",
			panelDisplayName: "Curves",
			autoVisible: true,
			width: 600,
			height: 650,
		},
		{
			mainPath: "./licensing/index.html",
			name: "licensing",
			type: "Modeless",
			// panelDisplayName: 'PP CEP Boilerplate | settings',
			autoVisible: true,
			width: 400,
			height: 300,
		},
	],
	build: {
		jsxBin: "copy",
		sourceMap: true,
	},
	zxp: {
		country: "US",
		province: "CA",
		org: "MyCompany",
		password: "mypassword",
		tsa: "http://timestamp.digicert.com/",
		sourceMap: false,
		jsxBin: "replace",
	},
	installModules: [],
	copyAssets: [],
};
export default config;
